export const Environment = {
  ApiUrl: process.env.REACT_APP_API_URL,
};
